import ApiService from './ApiService';

export default {
  /**
   * Returns an admin profile
   */
  profile() {
    return new Promise((resolve, reject) => {
      ApiService.request('GET', 'admin', {}).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
};
